<template>
    <div>
        <todo-form :entity-id="entityId"></todo-form>
    </div>
</template>

<script>
import todoForm from '@/components/pages/todo/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: { todoForm },

    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
